export default __webpack_public_path__ + "static/media/qualified.c4808045.svg";